import { css } from '@fable/theme'
import Tabs, { TabItem } from '../../../../components/tabs'
import { ProfileTab } from './types'

interface Props {
  activeTab: ProfileTab
  onChangeTab: (id: ProfileTab) => void
  showStats: boolean
}

const ProfileTabs: React.VFC<Props> = ({
  activeTab,
  onChangeTab,
  showStats,
}) => {
  const tabItems: TabItem[] = [
    {
      title: 'Lists',
      id: 'lists',
    },
    {
      title: 'Clubs',
      id: 'clubs',
    },
    {
      title: 'Reviews',
      id: 'reviews',
    },
    {
      title: 'Posts',
      id: 'posts',
    },
    // {
    //   title: 'Quotes',
    //   id: 'quotes',
    // },
  ]

  if (showStats) {
    tabItems.unshift({
      title: 'Stats',
      id: 'stats',
    })
  }

  return (
    <Tabs
      className={css`
        padding: 0 24px;
      `}
      activeTab={activeTab as string}
      onChangeTab={onChangeTab as (id: string) => void}
      items={tabItems}
      width="428px"
    />
  )
}

export default ProfileTabs
